<template>
  <div class="search">
        <div class="left">
            <slot name="back"></slot>
            <slot></slot>
        </div>
        <div class="right">
            <div class="filter">
                <slot name="filter"></slot>
            </div>
            <el-input
                placeholder="搜索"
                v-model="inputValue"
                clearable
                prefix-icon="el-icon-search"
                
            >
            </el-input>
            <el-button type="primary" icon="el-icon-search" style="margin:0 10px; marginLeft:20px;height:38px" size="small" @click="search">搜索</el-button>
            <el-button v-if="flag" type="success" icon="el-icon-plus" style="height:38px" size="small" @click="add">新增</el-button>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            inputValue:'',
            flag: true
        }
    },
    mounted(){
        if(this.$route.path == '/LoanManage' || this.$route.path == '/LoanHistory'|| this.$route.path == '/LockHistory'){
            this.flag = false
        }
    },
    methods:{
        search(){
            this.$emit('search')
        },
        add(){
            this.$emit('add')
        },
    },
    watch:{
        inputValue(){
            this.$emit('getInputValue',this.inputValue)
        },
    }
}
</script>

<style lang='scss' scoped>
.search{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    background: #fff;
    .left{
        width: 170px;
        font-weight: bold;
        padding: 10px;
        color: #1A1A1A;
    }
    .right{
        //width: 1800px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .el-input{
            flex: 1;
            margin-left: 40px;
        }
    }
    .filter{
        height: 100%;
        display: flex;
        align-items: center;
    }
}

</style>